import { render, staticRenderFns } from "./operatDemo.vue?vue&type=template&id=1fd22c10&scoped=true&"
import script from "./operatDemo.vue?vue&type=script&lang=js&"
export * from "./operatDemo.vue?vue&type=script&lang=js&"
import style0 from "./operatDemo.vue?vue&type=style&index=0&id=1fd22c10&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fd22c10",
  null
  
)

export default component.exports